import React from 'react';

type Props = {};

export default function GlobalDashboard({}: Props) {
  return <div>index</div>;
}
